export default __webpack_public_path__ + "static/media/6307-12gauge.df6c5813.pdf";